<footer class="of-footer">
  <div class="of-footer__content">
    <ul class="of-footer__links">
      <li class="of-footer__item">
        <a
          class="of-footer__link"
          href="https://portal.orthofi.com/Privacy/Index"
          >Online Privacy Notice</a
        >
      </li>
      <li class="of-footer__item">
        <a
          class="of-footer__link"
          href="https://portal.orthofi.com/TermsOfUse/Index"
          >Terms of Use</a
        >
      </li>
      <li class="of-footer__item">
        <a
          class="of-footer__link"
          href="https://portal.orthofi.com/Contact/Index"
          >Contact Us</a
        >
      </li>
      <li class="of-footer__item">
        <a class="of-footer__link" href="https://orthofi.com/about-us/"
          >About</a
        >
      </li>
    </ul>
    <p class="of-footer__fineprint">
      <span>© {{ year }} OrthoFi Inc.</span>
      <span>Denver, CO</span>
    </p>
  </div>
</footer>
